import { useEffect } from "react";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import AttendantListTableActions from "./components/table-action";
import AttendantSearchFilters from "../components/attendant-search-filters";
import { useAttendantStyles } from "../styles";
import { useAttendantListStyles } from "./styles";
import CustomPagination from "../../../Components/pagination";
import { dateformat } from "../../../utils/dateFormat";
import { useBreadcrumbs } from "../../../contexts/breadcrumb";
import EmptyState from "../../../Components/EmptyState";
import { useAttendanceLocalUserList } from "../../../services/api-tansquery/attendance-local/user/list";
import { useSearchParams } from "../../../hooks/useSearchParams";
import Avatar from "@material-ui/core/Avatar";
import HeadsetMic from "@material-ui/icons/HeadsetMic";

export default function AttendantList() {
    const { setBreadcrumbs } = useBreadcrumbs();
    const { classes } = useAttendantListStyles();
    const { classes: defaultClasses } = useAttendantStyles();
    const searchParams = useSearchParams();
    const { data: attendantList, isLoading } = useAttendanceLocalUserList({
        order_by: "-created_at",
        nome: searchParams.get("nome") || undefined,
        cpf: searchParams.get("cpf") || undefined,
        unidade: searchParams.get("unidade") || undefined,
    });

    const isEmpty = (attendantList?.results ?? []).length === 0;

    useEffect(() => {
        setBreadcrumbs((prev) => {
            const homeBreadcrumb = prev.find((_, index) => index === 0);
            return [
                homeBreadcrumb,
                {
                    label: "Atendentes",
                    path: "",
                    icon: HeadsetMic,
                },
            ];
        });
    }, [setBreadcrumbs]);

    return (
        <Box>
            <Box className={classes.header}>
                <Typography className={classes.title}>
                    Gestão de Atendentes
                </Typography>
            </Box>
            <Paper elevation={3}>
                <AttendantSearchFilters />
                <TableContainer className={defaultClasses.tableContainer}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell className={defaultClasses.tableTH}>
                                    Nome
                                </TableCell>
                                <TableCell className={defaultClasses.tableTH}>
                                    CPF
                                </TableCell>
                                <TableCell className={defaultClasses.tableTH}>
                                    Unidade Atual
                                </TableCell>
                                <TableCell className={defaultClasses.tableTH}>
                                    Setor Atual
                                </TableCell>
                                <TableCell className={defaultClasses.tableTH}>
                                    Adicionado em
                                </TableCell>
                                <TableCell className={defaultClasses.tableTH} />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {attendantList?.results.map((attendant) => (
                                <TableRow key={attendant.id} hover>
                                    <TableCell className={defaultClasses.tableCell}>
                                        <Box className={classes.userBox}>
                                            <Avatar />
                                            {attendant.user.first_name}
                                        </Box>
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        {attendant.cpf}
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        {attendant.unidade.nome}
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        {attendant.setor.nome}
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        {dateformat(attendant.created_at, true)}
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        <AttendantListTableActions attendant={attendant} />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    {isEmpty && (
                        <EmptyState
                            loading={isLoading}
                            loadingText="Carregando atendentes..."
                            message="Nenhum atendente encontrado."
                        />
                    )}
                </TableContainer>
                <Box className={defaultClasses.paginationContainer}>
                    <CustomPagination
                        count={attendantList?.count}
                        page={attendantList?.current}
                        totalPages={attendantList?.total_pages}
                    />
                </Box>
            </Paper>
        </Box>
    );
}
